module.exports = __webpack_public_path__ + "assets/9295c604d6ea691b9d84b58dc9b84b92-DSC_0784.jpg";